import {Actions, StateChanges} from './stateChanges'
import {AppConfig} from '../appConfig'
import axios from 'axios'
import {getDevApiSettings} from 'shared/js/devMode'
import {getNikudMap} from 'shared/js/commonHebrew'
import {handleTokenizationJson} from 'shared/js/handleTokenizationJson'
import backendRedirect from '../../backendRedirect'

const NAKDAN_SERVER = AppConfig.SERVER
const GENRE_CLASSIFY_SERVER = 'https://nakdan.dicta.org.il/genreclassify'
axios.defaults.headers = {
  'Content-Type': 'text/plain;charset=UTF-8'
}
const axiosInstance = axios.create({timeout: 60000})
const invalidInput = false

// function ignoreSurrounders (allText) {
//   return allText.replace(/([^\s])[([{]([^\s]*)[)\]}]/g, "$1$2").replace(/[([{]([^\s])*[)\]}]([^\s])/g, "$1$2")
// }

function getMapForRewrite (strippedText, mapForRewrite) {
  var textForApi = ''
  const whitespaceChars = [' ', '\t', '\r', '\n', '\v', '\f']
  strippedText.split('').forEach((ch, c) => {
    // console.log('char ' + c + ': ' + ch)
    var endOfLine = strippedText.slice(c).indexOf('\n')
    if ([-1, 0].includes(endOfLine)) endOfLine = strippedText.slice(c).length
    if ('()[]{}<>'.includes(ch) 
        || (ch === '?' && c < strippedText.length - 1 && !(whitespaceChars.includes(strippedText[c + 1])))
        || (whitespaceChars.includes(ch) && 
          ((textForApi.length === 0 && mapForRewrite.length)
            || !(strippedText.slice(c, c + endOfLine).split('').filter(x => !(('()[]{}<>' + whitespaceChars.join('')).includes(x))).length)))) {
      mapForRewrite.push({ charIndex: textForApi.length, charIgnored: ch })
      if (whitespaceChars.includes(ch)) {
        /* console.log('Whitespace pulled b/c ' + ((textForApi.length === 0 && mapForRewrite.length)
          ? 'textForApi.length === 0 && mapForRewrite.length'
          : "!(strippedText.slice(c).split('').filter(x => !('()[]{}<>' + whitespaceChars.join('').includes(x))).length)")) */
        // console.log('strippedText.slice(c):')
        // console.log(strippedText.slice(c))
        // console.log('endOfLine:')
        // console.log(endOfLine)
      }
    } else if (!(whitespaceChars.includes(ch) && (textForApi.length === 0
        || !(strippedText.slice(c).split('').filter(x => !(whitespaceChars.includes(x))).length)))) textForApi += ch
  })
  // console.log(Object.assign({}, mapForRewrite))  
  return textForApi
}

function assignOriginalNikudToTokens (responseData, mapForOriginalNikud) {
  var currentLetterIndex = 0
  var finished = mapForOriginalNikud.length === 0
  var currentNikudObj
  if (!finished) currentNikudObj = mapForOriginalNikud.shift()
  responseData.forEach(wordOrSep => {
    wordOrSep['originalNikud'] = ''
    wordOrSep.word.split('').forEach((ch) => {
      wordOrSep['originalNikud'] += ch
      if ('קראטוןםפשדגכעיחלךףזסבהנמצתץ'.includes(ch)) {
        if (!(wordOrSep.sep) && !finished && (currentNikudObj.letterIndex === currentLetterIndex)) {
          if (currentNikudObj.letter === ch) {
            wordOrSep['originalNikud'] += currentNikudObj.nikudOnLetter
            finished = mapForOriginalNikud.length === 0
            if (!finished) currentNikudObj = mapForOriginalNikud.shift()
          } else {
            // console.log('mismatch in assignOriginalNikudToTokens():')
            // console.log('currentLetterIndex: ' + currentLetterIndex + ', ch: ' + ch)
            // console.log('Nikud.letter: ' + currentNikudObj.letter + ', nikudOnLetter: ' + currentNikudObj.nikudOnLetter)
          }
        }
        currentLetterIndex += 1
      }
    })
  })
}

function assignRewritesToTokens (responseData, mapForRewrite) {
  var c = 0
  responseData.forEach(wordOrSep => {
    wordOrSep['reinsertionChars'] = []
    while (mapForRewrite.length 
        && (mapForRewrite[0].charIndex < c + wordOrSep.word.length
            || (wordOrSep.sep && mapForRewrite[0].charIndex === c + wordOrSep.word.length))) {
      var charObj = mapForRewrite.shift()
      wordOrSep.reinsertionChars.push({ charIndex: charObj.charIndex - c, reinsertionChar: charObj.charIgnored })
      /* console.log('added reinsertionChars record to wordOrSep "' + wordOrSep.word.replace('\n', '\\n')
        + '" index ' + (charObj.charIndex - c) + ': "' + charObj.charIgnored.replace('\n', '\\n') + '"') */
    }
    c += wordOrSep.word.length
  })
  if (mapForRewrite.length) { 
    responseData[responseData.length-1].reinsertionChars.push(...(mapForRewrite.map(
      obj => { return { charIndex: obj.charIndex, reinsertionChar: obj.charIgnored }})))
  }
}

export default {
  [Actions.RUN_NAKDAN]: function ({ commit, state }) {
    if (invalidInput) {
      // console.log('Invalid input.')
      return
    }
    commit(StateChanges.NAKDAN_RUNNING)
    var mapForRewrite, mapForOriginalNikud
    let chosenTextTypeName = state.preSubmissionOptions.chosenTextTypeName
    const abbrevProjectSettings = state.dropbox?.projectSettings?.abbreviation
    if (abbrevProjectSettings) chosenTextTypeName = abbrevProjectSettings.genreMode
    if (chosenTextTypeName === 'talmud') {
      try {
        const parsed = JSON.parse(state.forNakdanApiCall.text) // next line will only be run if it IS parseable
        if (parsed) {
          commit(StateChanges.SET_JSON_DATA_FOR_NAKDAN_API_CALL, parsed)
        }
      } catch { /* nothing needed since "try" is being used to parse IF it's parseable */ }
    }
    const originalTextForApi = state.forNakdanApiCall.text // note it will have chenged to "" if json parse worked
    if (originalTextForApi && (state.preSubmissionOptions.skipVoc || state.preSubmissionOptions.skipPartVoc)) {
      mapForOriginalNikud = []
      const fixedText = originalTextForApi.replace(/^[ְֱֲֳִֵֶַָׇֹֻּׁׂ]/g, '').replace(/([^\u05b0\u05b1\u05b2\u05b3\u05b4\u05b5\u05b6\u05b7\u05b8\u05c2\u05c1\u05b9\u05bc\u05bb\u05c7\u05d0-\u05ea])[ְֱֲֳִֵֶַָׇֹֻּׁׂ]*/g, '$1') // remove all nikud not "on a letter"
      const justLettersAndNikud = fixedText.replace(/[^\u05b0\u05b1\u05b2\u05b3\u05b4\u05b5\u05b6\u05b7\u05b8\u05c2\u05c1\u05b9\u05bc\u05bb\u05c7\u05d0-\u05ea]/g, '')
      const justLetters = fixedText.replace(/[^א-ת]/g, '')
      // console.log('justHebrewAndNikud: ' + justHebrewAndNikud)
      getNikudMap(justLettersAndNikud, justLetters, mapForOriginalNikud) // mapForOriginalNikud is built by passing as reference
    }
    var textForApi = state.forNakdanApiCall.text
    if (textForApi && !(state.preSubmissionOptions.splitParens)) {
      mapForRewrite = []
      const strippedText = state.forNakdanApiCall.text.replace(/[\r]/g, '').trim() // the abb. API will anyway
      textForApi = getMapForRewrite(strippedText, mapForRewrite) // mapForRewrite is built by passing as reference
    }
    const dataForApi = originalTextForApi ? textForApi : state.forNakdanApiCall.jsonData
    const requestObj = {
      task: backendRedirect.withinNakdan ? 'abbrexp' : 'nakdan',
      data: dataForApi,
      useTokenization: true
    }
    if (abbrevProjectSettings) {
      requestObj['metadata'] = abbrevProjectSettings
    } else requestObj['genre'] = state.preSubmissionOptions.chosenTextTypeName
    if (state.forNakdanApiCall.jsonData) requestObj['specialtalmud'] = true
    const userPermission = window.localStorage['permission-to-use-abbreviation-data'] // exists 
      && JSON.parse(window.localStorage['permission-to-use-abbreviation-data']) // i.e. the string is 'true'
    if (userPermission) {
      const userData = (state.account && state.account.isLoggedIn) ? (JSON.stringify({
        name: state.account.userData.name, email: state.account.userData.email}) + ' (gave permission)'): 'gave permission'
      requestObj['userData'] = userData
    }
    const devApiSettings = getDevApiSettings('abbreviation')
    if (devApiSettings) Object.assign(requestObj, devApiSettings)
    axiosInstance.post(NAKDAN_SERVER, JSON.stringify(requestObj))
      .then(function (response) {
        // console.log(textResponse)
        // const response = {data: JSON.parse(textResponse.data.replace(/(?<!"\S*)\d+(?!\S*")/g, "\"$&\"")) }
        // const response = {data: JSON.parse(textResponse.data.replace(/([[:])?(\d[\d.]*)([,}\]])/g, "$1\"$2\"$3")) }
        // console.log('response.data:')
        // console.log(response.data)
        handleTokenizationJson(response, requestObj)
        if (originalTextForApi && !(state.preSubmissionOptions.splitParens)) {
          assignRewritesToTokens(response.data, mapForRewrite) // tokens are assigned rewrites by passing as reference
        }
        if (originalTextForApi && (state.preSubmissionOptions.skipVoc || state.preSubmissionOptions.skipPartVoc)) {
          assignOriginalNikudToTokens(response.data, mapForOriginalNikud) // tokens are assigned rewrites by passing as reference
        }
        commit(StateChanges.SET_NAKDAN_RESULTS, response.data)
        // console.log(response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.NAKDAN_TIMED_OUT)
        } else {
          // eslint-disable-next-line no-console
          console.log(error)
          commit(StateChanges.NAKDAN_FAILED)
        }
      })
    if (AppConfig.USE_GENRE_CLASSIFICATION) {
      commit(StateChanges.GENRE_CLASSIFY_RUNNING)
      axiosInstance.post(GENRE_CLASSIFY_SERVER, JSON.stringify({
        data: textForApi,
        }))
        .then(function (response) {
          // console.log('genreClassifier response:')
          // console.log(response.data)
          commit(StateChanges.SET_GENRE_CLASSIFY_RESULTS, response.data)
        })
        .catch(function (error) {
          if (error.code === 'ECONNABORTED') {
            commit(StateChanges.GENRE_CLASSIFY_TIMED_OUT)
          } else {
            // eslint-disable-next-line no-console
            console.log(error)
            commit(StateChanges.GENRE_CLASSIFY_FAILED)
          }
        })
    }
  }
}
